import { gsap, ScrollTrigger, screenSm } from './1.1_animations-defaults.js';

import Swiper from 'swiper';
import { Navigation, Pagination, Keyboard, FreeMode, Autoplay, EffectFade, Thumbs } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/keyboard';
import 'swiper/css/grid';
import 'swiper/css/autoplay';
import 'swiper/css/effect-fade';
import 'swiper/css/thumbs';

const SECTION_ID = 'culture-page-section-b';
const SWIPER_CLASS = 'swiper';
const SWIPER_THUMB_CLASS = 'swiper-thumb';

class SwiperCultureSectionB {
    constructor() {
        this._section = document.getElementById(SECTION_ID);
        this._section && this._run();
    }
    _run() {
        this._swiper = this._section.querySelector(`.${SWIPER_CLASS}`);
        this._swiperThumb = this._section.querySelector(`.${SWIPER_THUMB_CLASS}`);

        if (this._swiper) {
            if (innerWidth >= screenSm) {
                this._interval = this._swiper.dataset.interval * 1000;
            } else {
                this._interval = 0;
            }

            this._activateSwiperThumb();
            this._activateSwiper();
            if (innerWidth >= screenSm) {
                this._activateOnScroll();
            }
        }
    }

    _activateSwiperThumb() {
        this._swiperThumbSection = new Swiper(this._swiperThumb, {
            modules: [Navigation, Pagination, Keyboard, Autoplay, EffectFade, FreeMode],
            speed: 500,
            loop: false,
            slidesPerView: 'auto',
            centeredSlides: false,
            grabCursor: false,
            allowTouchMove: true,
            autoHeight: false,
            freeMode: true,
            watchSlidesProgress: true,
        });
    }
    _activateSwiper() {
        this._swiperSection = new Swiper(this._swiper, {
            modules: [Navigation, Pagination, Keyboard, Autoplay, EffectFade, Thumbs],
            speed: 500,
            loop: false,
            slidesPerView: 'auto',
            centeredSlides: false,
            grabCursor: true,
            allowTouchMove: true,
            autoHeight: false,
            effect: 'fade',
            fadeEffect: {
                crossFade: true,
            },
            autoplay: this._interval
                ? {
                      delay: this._interval,
                      pauseOnMouseEnter: false,
                  }
                : false,
            on: {
                init: function () {
                    this.autoplay.stop();
                },
            },
            keyboard: {
                enabled: true,
            },
            navigation: {
                nextEl: '.arrow-next',
                prevEl: '.arrow-prev',
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'fraction',
                renderFraction: function (currentClass, totalClass) {
                    return '<span class="' + currentClass + '"></span>/<span class="' + totalClass + '"></span>';
                },
            },
            thumbs: {
                swiper: this._swiperThumbSection,
            },
        });
    }
    _activateOnScroll() {
        ScrollTrigger.create({
            trigger: this._section,
            start: 'top bottom',
            end: 'bottom top',
            markers: false,
            onEnter: () => {
                this._swiperSection.autoplay.start();
            },
            onLeave: () => {
                this._swiperSection.autoplay.pause();
            },
            onLeaveBack: () => {
                this._swiperSection.autoplay.pause();
            },
            onEnterBack: () => {
                this._swiperSection.autoplay.start();
            },
        });
    }
}

const swiperCultureSectionB = new SwiperCultureSectionB();
